import React, { Component } from 'react';
import ProductItem from '../../product-item';

export default class ParagraphShop extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          {this.props.content.entities.map((item, index) =>
            <div className="col col-12 col-lg-4 py-3">
              <ProductItem product={item}/>
            </div>
          )}
        </div>
      </div>
    );
  }
}
